import FormItem from "@components/formItem";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import { Box, BoxTitle, Content, ContentTitle, StakeInput } from "../baseItems";
import Base from "./base";

export default class Skrill extends Base {
	getStep1(translate) {
		const { method } = this.props;
		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					{method === "SkrillDigitalWallet" && (
						<FormItem
							onRegister={() => this.registerField({ name: "bank_account_number" })}>
							<Box>
								<BoxTitle>{translate("EMAIL")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									onChange={this.onEnterValue.bind(this, "bank_account_number")}
								/>
							</Box>
						</FormItem>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const { stake, bank_account_number, selectedCurrency } = this.state;
		let withdrawData = {
			method: method.split("Skrill")[1],
			type: "Skrill",
			username: getUser().username,
			amount: {
				value: stake,
				currency: selectedCurrency,
			},
			note: new Date(),
		};
		if (method === "SkrillDigitalWallet") {
			withdrawData.bank_account_type = "Email";
			withdrawData.bank_account_number = bank_account_number;
		}
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
